import React, { Fragment } from "react";
import Grid from "@mui/material/Grid";
import Collapse from "@mui/material/Collapse";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import { Link } from "react-router-dom";
import { totalPrice } from "../../utils";

// images
import visa from "../../images/icon/visa.png";
import mastercard from "../../images/icon/mastercard.png";
import skrill from "../../images/icon/skrill.png";
import paypal from "../../images/icon/paypal.png";

import CheckWrap from "../CheckWrap";

const cardType = [
  { id: "1", title: "Visa", img: visa },
  { id: "2", title: "MasterCard", img: mastercard },
  { id: "3", title: "Skrill", img: skrill },
  { id: "4", title: "PayPal", img: paypal },
];

const CheckoutSection = ({ cartList }) => {
  // States for form inputs and tabs
  const [tabs, setExpanded] = React.useState({
    coupon: false,
    login: false,
    payment: true,
  });
  const [forms, setForms] = React.useState({
    coupon_key: "",
    fname: "",
    lname: "",
    country: "",
    district: "",
    address: "",
    post_code: "",
    email: "",
    phone: "",
    note: "",
    payment_method: "cash",
    card_type: "",
    fname2: "",
    lname2: "",
    country2: "",
    district2: "",
    address2: "",
    post_code2: "",
    email2: "",
    phone2: "",
    card_holder: "",
    card_number: "",
    cvv: "",
    expire_date: "",
  });
  const [differentShipping, setDifferentShipping] = React.useState(false);

  // Handle tab toggles
  const faqHandler = (name) => {
    setExpanded((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  // Handle form changes
  const changeHandler = (e) => {
    setForms({ ...forms, [e.target.name]: e.target.value });
  };

  return (
    <Fragment>
      <div className="wpo-checkout-area section-padding">
        <div className="container">
          <div className="single-page-title">
            <h2>Your Checkout</h2>
            <p>Review your details and complete your order.</p>
          </div>
          <div className="checkout-wrap">
            <div className="row">
              <div className="col-lg-8 col-12">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="coupon-wrap">
                      <div
                        className="coupon-toggle"
                        onClick={() => faqHandler("login")}
                      >
                        <i className="fi flaticon-user-profile"></i> Returning
                        customer? <span>Click Here to Login</span>
                      </div>
                      <Collapse in={tabs.login} timeout="auto" unmountOnExit>
                        <div className="login-form">
                          <p>
                            If you have shopped with us before, enter your
                            details below.
                          </p>
                          <TextField fullWidth placeholder="Name" required />
                          <TextField
                            fullWidth
                            type="email"
                            placeholder="Email"
                            required
                          />
                          <button type="submit" className="theme-btn">
                            Login
                          </button>
                        </div>
                      </Collapse>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="coupon-wrap">
                      <div
                        className="coupon-toggle"
                        onClick={() => faqHandler("coupon")}
                      >
                        <i className="fi flaticon-coupon"></i> Have a Coupon?{" "}
                        <span>Click Here to Enter</span>
                      </div>
                      <Collapse in={tabs.coupon} timeout="auto" unmountOnExit>
                        <div className="coupon-form">
                          <p>Enter your coupon code below:</p>
                          <TextField
                            fullWidth
                            type="text"
                            placeholder="Coupon Code"
                          />
                          <button className="theme-btn">Apply</button>
                        </div>
                      </Collapse>
                    </div>
                  </div>
                </div>
                {/* Billing & Shipping Information */}
                <Grid container spacing={3} className="billing-info">
                  <Grid item sm={6} xs={12}>
                    <TextField
                      fullWidth
                      label="First Name"
                      name="fname"
                      value={forms.fname}
                      onChange={changeHandler}
                      className="formInput"
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <TextField
                      fullWidth
                      label="Last Name"
                      name="lname"
                      value={forms.lname}
                      onChange={changeHandler}
                      className="formInput"
                    />
                  </Grid>
                  {/* Additional fields and form inputs */}
                  {/* Payment Options */}
                  <div className="payment-method">
                    <h3>Payment Method</h3>
                    <RadioGroup
                      aria-label="Payment Method"
                      name="payment_method"
                      value={forms.payment_method}
                      onChange={changeHandler}
                    >
                      <FormControlLabel
                        value="cash"
                        control={<Radio />}
                        label="Direct Bank Transfer"
                      />
                      <FormControlLabel
                        value="card"
                        control={<Radio />}
                        label="Cash On Delivery"
                      />
                      <FormControlLabel
                        value="online"
                        control={<Radio />}
                        label="Online Payment"
                      />
                    </RadioGroup>
                    <Collapse
                      in={forms.payment_method === "cash"}
                      timeout="auto"
                      unmountOnExit
                    >
                      <div className="payment-details">
                        <ul>
                          {cardType.map((item, index) => (
                            <li key={index}>
                              <input
                                type="radio"
                                id={item.id}
                                name="card_type"
                              />
                              <label htmlFor={item.id}>
                                <img src={item.img} alt={item.title} />
                              </label>
                            </li>
                          ))}
                        </ul>
                        <CheckWrap />
                      </div>
                    </Collapse>
                  </div>
                </Grid>
              </div>
              {/* Order Summary */}
              <div className="col-lg-4 col-12">
                <div className="order-summary">
                  <h3>Your Order</h3>
                  {cartList.map((item, index) => (
                    <div className="order-item" key={index}>
                      <img src={item.proImg} alt={item.title} />
                      <span>
                        {item.title} (x{item.qty})
                      </span>
                      <span>${item.price}</span>
                    </div>
                  ))}
                  <h4>Total: ${totalPrice(cartList)}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CheckoutSection;
